<template>
    <div v-if="eventData">
        <div
            v-if="eventData && eventData.alternativeOrganizerName && eventData.alternativeOrganizerLogo"
            class="img-container">
            <img
                class="img"
                :src="eventData.alternativeOrganizerLogo"
                :alt="eventData.alternativeOrganizerName">
        </div>
        <div
            v-else-if="eventData && eventData.organizerLogo && !eventData.alternativeOrganizerName"
            class="img-container">
            <img
                class="img"
                :src="eventData.organizerLogo"
                :alt="eventData.organizerName">
        </div>
    </div>
</template>

<script>
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";

export default {
    name: "AnbieterLogo",
    mixins: [mainRegistrationMixin]
}
</script>

<style scoped>
.img-container {
    overflow: hidden;
    width: 100%;
    height: 100%;
}

.img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>